import { render } from "./member-support.vue?vue&type=template&id=7901944c"
import script from "./member-support.vue?vue&type=script&lang=js"
export * from "./member-support.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__